import { useNavigate, useLocation } from "react-router-dom";
import { inProgressPaths } from "@core/config/InProgressPaths";

const IntegrationInProgress: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const dashboardLink =
    inProgressPaths.find((p) => p.path === pathname)?.dashboard || "/";

  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      <h1 className="text-2xl font-bold text-indigo-600">
        Integration in Progress 🚧
      </h1>
      <p className="text-gray-600 mt-2">
        Contact your system administrator for better visibility.
      </p>
      {/* <button
        onClick={() => navigate(dashboardLink)}
        className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded"
      >
        Go to Home
      </button> */}
    </div>
  );
};

export default IntegrationInProgress;
